<template>
  <div class="bottom-checkout-container">
    <img src="@/assets/success.png" class="logo-success" />
    <span class="message">Item has been added to your cart</span>
    <app-link to="checkout">
      <div class="checkout-button normal-button">
        <span class="checkout-text">Check out</span>
      </div>
    </app-link>
    <div class="continue-button normal-button" @click="continueClick">
      <span class="continue-text">Continue Shopping</span>
    </div>
  </div>
</template>
<script>
import AppLink from "@/components/Link";
export default {
  name: "BottomCheckout",
  components: {
    AppLink
  },
  props: {},
  methods: {
    checkoutClick() {
      this.$emit("onCheckoutClick");
    },
    continueClick() {
      this.$emit("onContinueClick");
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-checkout-container {
  background-color: #2E2323;
  height: 295px;
  display: flex;
  flex-direction: column;
  font-family: "SFUIText-Semibold", -apple-system;
  font-weight: 600;

  .logo-success {
    width: 48px;
    height: 48px;
    align-self: center;
    margin-top: 25px;
  }
  .message {
    font-size: 18px;
    font-weight: 600;
    color: white;
    align-self: center;
    margin-top: 20px;
  }
  .checkout-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: white;
    border-radius: 5px;
    margin-left: calc(50% - 250px);
    margin-right: calc(50% - 250px);
    margin-top: 30px;
  }
  .continue-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border: 2px solid white;
    border-radius: 5px;
    margin-left: calc(50% - 250px);
    margin-right: calc(50% - 250px);
    margin-top: 20px;
  }
  @media only screen and (max-width: 600px) {
    .continue-button {
      margin-left: 20px;
      margin-right: 20px;
    }
    .checkout-button {
      margin-left: 20px;
      margin-right: 20px;
    }
  }
  .checkout-text {
    color: #2e2323;
    font-size: 16px;
  }
  .continue-text {
    color: white;
    font-size: 16px;
  }
}
</style>